export default __webpack_public_path__ + "static/media/kiama5.8cd7d24c.jpg";